import React, { useMemo } from 'react';
import { v4 as uuidv4 } from "uuid";
import { utils } from "../../utils";

const SubMenus = ({ productData, totalCount, index, cartInfoDisplay, storeId }) => {
	let half = totalCount / 2;
	if (index < half) {
		return (
			<>
				<div
					role="button"
					tabIndex="0"
					className={`${
						parseFloat(productData.productStatus) === 1
							? "_194c2bm"
							: "_194c2bm unavailableItem"
					}`}
					onClick={() =>
						`${
							parseFloat(productData.productStatus) === 1
								? cartInfoDisplay(storeId, productData, "custom")
								: ""
						}`
					}
				>
					<div className="_15q0jjh">
						<div className="_qsnllp">
							<p className="_1n57n8z">{`${productData.name}`}</p>
							<p className="_vlgzaz">{`${productData.description}`}</p>
							{productData.price > 0 && (
								<p className="_lu8b5g">
									{`${productData.currency}`}
									{`${(productData.price / 100).toFixed(2)}`}
								</p>
							)}
							{productData.price <= 0 && <p className="_lu8b5g"></p>}
						</div>
					</div>
					{productData.image && (
						<div
							className={`${
								parseFloat(productData.productStatus) === 1
									? "_1pbw5a2"
									: "_1pbw5a2 unavailableItemImg"
							}`}
							style={{
								backgroundImage:
									"url(" +
									productData.image +
									"?fit=crop&amp;w=320&amp;h=320)",
								flex: 1,
								justifyContent: 'center',
								alignItems: 'center',
								alignSelf: 'center',
								maxWidth: 122,
								width: 120,
								height: 120,
								objectFit: 'cover',
								objectPosition: 'center',
							}}
						></div>
					)}
				</div>
				<hr className="_5lfk5c" />
			</>
		);
	} else {
		return null;
	}
};

const SubMenus2 = ({ productData, totalCount, index, cartInfoDisplay, storeId }) => {
// 	//console.log(productData);
	let half = totalCount / 2;
	if (index >= half) {
		return (
			<>
				<div
					role="button"
					tabIndex="0"
					className={`${
						parseFloat(productData.productStatus) === 1
							? "_194c2bm"
							: "_194c2bm unavailableItem"
					}`}
					onClick={() =>
						`${
							parseFloat(productData.productStatus) === 1
								? cartInfoDisplay(storeId, productData, "custom")
								: ""
						}`
					}
				>
					<div className="_15q0jjh">
						<div className="_qsnllp">
							<p className="_1n57n8z">{`${productData.name}`}</p>
							<p className="_vlgzaz">{`${productData.description}`}</p>
							{productData.price > 0 && (
								<p className="_lu8b5g">
									{`${productData.currency}`}
									{`${(productData.price / 100).toFixed(2)}`}
								</p>
							)}
							{productData.price <= 0 && <p className="_lu8b5g"></p>}
						</div>
					</div>
					{productData.image && (
						<div
							className={`${
								parseFloat(productData.productStatus) === 1
									? "_1pbw5a2"
									: "_1pbw5a2 unavailableItemImg"
							}`}
							style={{
								backgroundImage:
									"url(" +
									productData.image +
									"?fit=crop&amp;w=320&amp;h=320)",
								flex: 1,
								justifyContent: 'center',
								alignItems: 'center',
								alignSelf: 'center',
								maxWidth: 122,
								width: 120,
								height: 120,
								objectFit: 'cover',
								objectPosition: 'center',
							}}
						></div>
					)}
				</div>
				<hr className="_5lfk5c" />
			</>
		);
	} else {
		return null;
	}
};

const StoreMenuData = ({ entryData, cartInfoDisplay, storeId, randomColor, bgColor}) => {

	//console.table(entryData.flatMap(e => e.productList.map(p => ({ header: e.headerTitle, id: p.id, name: p.name })));

	const keyedData2 = useMemo(
    () =>
      entryData.map(section => ({
        ...section,
        productList: section.productList.map(p => ({
          ...p,
          _leftKey:  `left-${p.id}-${uuidv4().slice(0, 4)}`,
          _rightKey: `right-${p.id}-${uuidv4().slice(0, 4)}`,
        })),
      })),
    [entryData]
  );

	const keyedData = useMemo(() => {
	  const seenHeaders = new Set();

	  return entryData.reduce((acc, section, idx) => {
	    const title = section.headerTitle;

	    // 1️⃣  Skip duplicate headers
	    if (seenHeaders.has(title)) {
	      return acc;
	    }
	    seenHeaders.add(title);

	    // 2️⃣  De-duplicate productList by id
	    const seenIds = new Set();
	    const uniqueProducts = section.productList.filter(p => {
	      if (seenIds.has(p.id)) {
	        return false;
	      }
	      seenIds.add(p.id);
	      return true;
	    });

	    acc.push({
	      ...section,
	      productList: uniqueProducts.map(p => ({
	        ...p,
	        _leftKey:  `left-${p.id}-${uuidv4().slice(0, 4)}`,
	        _rightKey: `right-${p.id}-${uuidv4().slice(0, 4)}`,
	      })),
	    });

	    return acc;
	  }, []);
	}, [entryData]);

	return (
		<div>
			{keyedData.map((eData, index) => (
				<div key={`${eData.headerID}${index}`} data-c={`${eData.headerID}${index}`} r-color={randomColor}>
          <div>
            <div>
              <div className="_yq7j8e">
                <a
                  className="_rnsmcq"
                  id={`${eData.headerID}`}
                  href={`#${eData.headerID}`}
                >
                  {eData.headerTitle}
                </a>
                <div className="_18z5nku">
                  <div
                    className="_1yc6rdp"
                    style={{
                      border: `1px solid ${randomColor}`,
                      backgroundColor: bgColor,
                    }}
                  >
                    <svg
                      className="_1dcg472"
                      xmlns="http://www.w3.org/2000/svg"
                      width={15}
                      height={15}
                      aria-hidden="true"
                      viewBox="0, 0, 400, 400"
                    >
                      <title>List</title>
                      <g className="svgg">
                        <path
                          className="path0"
                          d="m2.5,373.97a17.87,21.62 0 0 1 17.87,-21.62l357.35,0a17.87,21.62 0 0 1 0,43.23l-357.35,0a17.87,21.62 0 0 1 -17.87,-21.62zm0,-172.93a17.87,21.62 0 0 1 17.87,-21.62l357.35,0a17.87,21.62 0 0 1 0,43.23l-357.35,0a17.87,21.62 0 0 1 -17.87,-21.62zm0,-172.93a17.87,21.62 0 0 1 17.87,-21.62l357.35,0a17.87,21.62 0 0 1 0,43.23l-357.35,0a17.87,21.62 0 0 1 -17.87,-21.62z"
                          stroke="none"
                          fill={randomColor}
                          fillRule="evenodd"
                        ></path>
                      </g>
                    </svg>
                    <div
                      className="_1gg3ue"
                      style={{ color: randomColor }}
                    >{`${eData.headerTitle}`}</div>
                  </div>

                  <div className="_1743i26" role="region">
										<div className="_19hi95f">
										  {eData?.productList.map((productListData, index) => (
										    <SubMenus
										      productData={productListData}
										      totalCount={eData.productList.length}
										      index={index}
										      cartInfoDisplay={cartInfoDisplay}
										      storeId={storeId}
													key={productListData._leftKey}
										    />
										  ))}
										</div>
										<div className="_19hi95f">
										  {eData?.productList.map((productListData, index) => (
										    <SubMenus2
										      productData={productListData}
										      totalCount={eData.productList.length}
										      index={index}
										      cartInfoDisplay={cartInfoDisplay}
										      storeId={storeId}
													key={productListData._rightKey}
										    />
										  ))}
										</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
			))}
		</div>
	);
}

export default StoreMenuData;
